"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.form.title': 'Accesso',
    'login.form.hero.title': 'Bentornato',
    'login.form.hero.description': 'Per favore usa le tue credenziali per accedere.',
    'login.form.hero.register_link_text': 'Se non sei ancora membro, per favore',
    'login.form.hero.register_link': 'registrati qui',
};
